export default "__VITE_ASSET__D5dUrGAS__"